import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { WebSocketContext } from '@/contexts/WebSocketContext';
import { CMDPsTokenUpdate } from '@/models/cmd/live';
import {
    GA_EVENT_CATEGORY,
    GA_LOBBY_EVENT_NAME,
    getNavTab,
    sendGA,
} from '@/utils/ga';
import { IconButton } from '@mui/material';
import { motion } from 'framer-motion';
import { SVGProps, useContext, useState } from 'react';
const updateBalance = new CMDPsTokenUpdate();
export const RefreshBalance = (props: SVGProps<SVGSVGElement>) => {
    const { sendCommand } = useContext(WebSocketContext);
    const [rotate, setRotate] = useState(0);
    const { playButtonAudio } = useContext(AudioPlayContext);
    const onClickHandler = () => {
        playButtonAudio();
        sendCommand(updateBalance);
        setRotate(r => r - 720);
        const currentPage = getNavTab();
        sendGA(
            GA_LOBBY_EVENT_NAME.REFRESH_BAL,
            GA_EVENT_CATEGORY.ENGAGEMENT,
            currentPage
        );
    };
    return (
        <IconButton
            onClick={onClickHandler}
            sx={{
                padding: 0,
                width: '100%',
                height: '100%',
                '&.MuiButtonBase-root:hover': {
                    bgcolor: 'transparent',
                },
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 26 27"
                width="100%"
                height="100%"
                fill="none"
                {...props}
            >
                <motion.path
                    d="M17.6459 10.9596L15.8103 12.8044C15.5998 13.016 15.7445 13.373 16.0406 13.373H17.2183C17.2183 15.5616 15.4485 17.3403 13.2708 17.3403C12.7511 17.3403 12.2445 17.2411 11.7906 17.0494C11.5537 16.9502 11.284 17.0229 11.1063 17.2015C10.7708 17.5387 10.8892 18.1073 11.33 18.2858C11.9287 18.5305 12.5866 18.6627 13.2708 18.6627C16.1788 18.6627 18.5341 16.2956 18.5341 13.373H19.7117C20.0078 13.373 20.1525 13.016 19.942 12.811L18.1064 10.9662C17.9814 10.834 17.7709 10.834 17.6459 10.9596ZM9.32341 13.373C9.32341 11.1844 11.0932 9.40574 13.2708 9.40574C13.7906 9.40574 14.2972 9.50492 14.7511 9.69668C14.988 9.79586 15.2577 9.72312 15.4353 9.5446C15.7709 9.20738 15.6524 8.63873 15.2116 8.46021C14.613 8.21556 13.9551 8.08331 13.2708 8.08331C10.3629 8.08331 8.00761 10.4505 8.00761 13.373H6.82996C6.5339 13.373 6.38917 13.7301 6.59969 13.9351L8.43525 15.7798C8.56683 15.9121 8.77078 15.9121 8.90236 15.7798L10.7379 13.9351C10.9419 13.7301 10.7971 13.373 10.5011 13.373H9.32341Z"
                    fill="#E2B875"
                    animate={{ rotate: rotate }}
                    transition={{
                        repeat: 0,
                        repeatType: 'loop',
                        duration: 1,
                    }}
                />
            </svg>
        </IconButton>
    );
};
